import { Params } from '@angular/router';
import { AccountType } from '../../constants/account-types';

/** Main test-window menu tab query key (ABED pattern). */
export const TC_TAB_QUERY = 'tab';

/** Scoring window id to pre-select on the Scoring Windows tab. */
export const TC_MARKING_WINDOW_QUERY = 'marking_window';

export const TC_TAB_SCORING_WINDOWS = 'SCORING_WINDOWS';

export interface IMarkingWindowTcLink {
  routerLink: string[];
  queryParams: Params;
}

/** Absolute route to a test window (no query params). */
export const testWindowPath = (
  lang: string,
  testCtrlGroupId: number,
  testWindowId: number,
): string[] => [
  '/',
  lang,
  AccountType.TEST_CTRL,
  'test-window',
  'ctrl-group',
  String(testCtrlGroupId),
  'window',
  String(testWindowId),
];

/** Deep link to Scoring Windows tab + optional marking window pre-selection. */
export const markingWindowTcLink = (
  lang: string,
  markingWindowId: number,
  testCtrlGroupId?: number,
  testWindowId?: number,
): IMarkingWindowTcLink | null => {
  if (testCtrlGroupId == null || testWindowId == null) return null;
  return {
    routerLink: testWindowPath(lang, testCtrlGroupId, testWindowId),
    queryParams: {
      [TC_TAB_QUERY]: TC_TAB_SCORING_WINDOWS,
      [TC_MARKING_WINDOW_QUERY]: String(markingWindowId),
    },
  };
};

/** Scoring Leader non-working hours page for another scoring window in scope. */
export const markingWindowScorLeadLink = (
  lang: string,
  markingWindowId: number,
): IMarkingWindowTcLink => ({
  routerLink: ['/', lang, AccountType.SCOR_LEAD, 'non-working-hours', String(markingWindowId)],
  queryParams: {},
});

/**
 * @deprecated Use markingWindowTcLink for navigation; path-only links omit tab/window selection.
 */
export const markingWindowDetailPath = (
  lang: string,
  markingWindowId: number,
  testCtrlGroupId?: number,
  testWindowId?: number,
): string[] => {
  const link = markingWindowTcLink(lang, markingWindowId, testCtrlGroupId, testWindowId);
  if (link) return link.routerLink;
  return ['/', lang, AccountType.TEST_CTRL, 'marking-window', String(markingWindowId)];
};

export const markingWindowDetailQueryParams = (
  markingWindowId: number,
): Params => ({
  [TC_TAB_QUERY]: TC_TAB_SCORING_WINDOWS,
  [TC_MARKING_WINDOW_QUERY]: String(markingWindowId),
});
